// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import type { JSX } from 'react';

interface RevokeAllModalProps {
  opened: boolean;
  sweName: string;
  patientCount: number;
  loading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function RevokeAllModal({
  opened,
  sweName,
  patientCount,
  loading,
  onConfirm,
  onClose,
}: RevokeAllModalProps): JSX.Element {
  return (
    <Modal opened={opened} onClose={onClose} title="Revoke All Access" data-testid="revoke-all-modal">
      <Stack gap="md">
        <Stack gap="xs">
          <Text>
            This action will revoke access for <strong>{sweName}</strong> from all granted patients.
          </Text>
          <Text fw={600}>
            {patientCount} patient{patientCount === 1 ? '' : 's'} will lose access
          </Text>
        </Stack>
        <Group justify="flex-end" gap="xs">
          <Button variant="light" onClick={onClose} disabled={loading} data-testid="revoke-all-cancel-button">
            Cancel
          </Button>
          <Button color="red" onClick={onConfirm} loading={loading} data-testid="revoke-all-confirm-button">
            Revoke All
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
